import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SsoService } from '../sso.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AbstractSigaleComponent } from '../../../components/abstract-sigale.component';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'bouton-sso-azure',
	templateUrl: './bouton-sso-azure.component.html',
	styleUrls: ['./bouton-sso-azure.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslateModule]
})
export class BoutonSsoAzureComponent extends AbstractSigaleComponent {

	@Output()
	authentifie: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	erreur: EventEmitter<HttpErrorResponse> = new EventEmitter<HttpErrorResponse>();

	@Input()
	autresOptionsPossiblesVisible: boolean;
	@Output()
	autresOptionsPossiblesVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input()
	estSsoOnly: boolean = false;

	@Input()
	nomUtilisateurMicrosoftConnecte: string;

	loading: boolean = false;

	constructor(private ssoService: SsoService, private router: Router) {
		super();
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this.ssoActif()) {
			this.ssoService.getIPublicClientApplication().handleRedirectPromise().then((result) => {
				if (result) {
					this.ssoService.getIPublicClientApplication().setActiveAccount(result.account);
					this.nomUtilisateurMicrosoftConnecte = this.ssoService.recupererNomUtilisateurConnecte();
					const deconnexionManuelle = localStorage.getItem(this.ssoService.ATTRIBUT_DECONNEXION_MANUELLE);
					// Lorsque l'utilisateur accède à la mire de connexion après s'être authentifié via le portail Microsoft, on veut le connecter automatiquement sans avoir à cliquer sur le bouton
					// Pour cela, on vérifie s'il s'est retrouvé sur la mire de connexion sans token et sans demande de déconnexion
					if ((deconnexionManuelle == undefined || !JSON.parse(deconnexionManuelle)) && !localStorage.getItem('access_token')) {
						this.loginAvecMicrosoft();
					}
				}
				else {
					// Cas où la redirection est terminée ou inexistante → récupérer l'account actif
					const currentAccounts = this.ssoService.getIPublicClientApplication().getAllAccounts();
					if (currentAccounts.length > 0) {
						this.ssoService.getIPublicClientApplication().setActiveAccount(currentAccounts[0]);
						this.nomUtilisateurMicrosoftConnecte = this.ssoService.recupererNomUtilisateurConnecte();
					}
				}
			}).catch((error) => {
				console.error('Erreur handleRedirectPromise:', error);
			});
		}
	}

	/**
	 * Détermine si le Sso est actif
	 *
	 * @return true si le sso est actif, false sinon
	 */
	ssoActif(): boolean {
		return this.ssoService?.ssoActif();
	}

	/**
	 * Connexion avec microsoft à l'application
	 */
	loginAvecMicrosoft(): void {
		this.loading = true;
		this.ssoService.loginAvecMicrosoft()
			.pipe(finalize(() => this.loading = false))
			.subscribe({
				next: () => {
					// Dans le cas d'une application full angular, on utilise le router angular, on redirige via ce router sur la page principale de l'application
					if (!this.modeApplicationCohabitation) {
						this.router.navigate(['/']);
					}
					// On émet l'évènement d'authentification
					this.authentifie.emit();
				},
				error: error => {
					this.erreur.emit(error);
				}
			});

	}

	/**
	 * Affiche/Cache la connexion classique login/mot de passe
	 */
	toggleAutreOptionsPossibles() {
		this.autresOptionsPossiblesVisible = !this.autresOptionsPossiblesVisible;
		this.autresOptionsPossiblesVisibleChange.emit(this.autresOptionsPossiblesVisible);
	}
}
